module.exports = __webpack_public_path__ + "media/styles/images/png/logo-076d4407ad25a0cc638ef2341fd52144.png";